export default __webpack_public_path__ + "static/media/gq.ad0ccfc2.svg";